<template>
  <v-dialog v-model="dialog" width="800">
    <v-card class="pa-10">
      <v-icon x-large class="v-icon-delete">
        mdi-delete-alert-outline
      </v-icon>

      <div v-if="currentReviewItem">
        <div class="text-h6 pp-center">
          Are you sure you want to delete the Review of "{{ currentReviewItem.title }}"?
        </div>

        <p class="pp-center pb-5">
          This review will be deleted immediately. You can't undo this action.
        </p>
      </div>

      <div v-else>
        <UnavailableContent />
      </div>

      <Loading  v-if="reviewItemLoading" />

      <ConfirmCancelButtons
          :item="currentReviewItem"
          :confirm-disabled="reviewItemLoading"
          confirm-text="Delete Review"
          :confirm-action="deleteItemConfirm"
          cancel-class="mr-5"
          :cancel-action="closeDialog"
      />

    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Loading from "@/components/common/Loading";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import UnavailableContent from "@/components/common/UnavailableContent";

export default {
  name: "ReviewDelete",
  components: {
    UnavailableContent, Loading, ConfirmCancelButtons,
  },
  computed: {
    ...mapState(['currentReviewItem']),
    ...mapGetters(['reviewApiError', 'openDialog', 'currentReviewItem', 'reviewItemLoading']),
    dialog: {
      get () {
        return this.openDialog === 'reviewDelete';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['deleteReview', 'clearReviewItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearReviewItems();
    },
    async deleteItemConfirm() {
      const deleted = await this.deleteReview(this.currentReviewItem);
      if (deleted) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>
